import angular from 'angular';

angular.module('cloudX').directive('cxJurisdictionSelect', [
  '$rootScope',
  '$filter',
  'dataCache',
  function($rootScope, $filter, dataCache) {
    return {
      restrict: 'E',
      template:
        '<a href="#" editable-select="value" onbeforesave="save({newValue:$data})" e-ng-options="item.id as item.label for item in options | orderBy:\'label\'" e-placeholder="{{placeholder}}">' +
        '<span ng-show="value">{{value | translateList:\'jurisdiction\'}}</span><i class="glyphicon glyphicon-pencil" ng-show="!value"></i></a>',
      scope: {
        value: '=data',
        save: '&',
      },
      link: function($scope) {
        var mapOptions = function() {
          $scope.placeholder = $filter('translateList')(null, 'jurisdiction') || '';
          $scope.options = dataCache.getArray('jurisdiction').map(function(c) {
            return {
              id: c.id,
              label: $filter('translateList')(c.id, 'jurisdiction', c.name),
            };
          });
        };

        mapOptions();
        var deregistration = $rootScope.$on('$translateChangeSuccess', mapOptions);
        $scope.$on('$destroy', deregistration);
      },
    };
  },
]);
